import cx from 'classnames';
import { forwardRef, type HTMLAttributes } from 'react';
import styles from './FormListbox.scss';

export const FormListbox = forwardRef<
  HTMLUListElement,
  HTMLAttributes<HTMLUListElement> & { darkMode?: boolean }
>(({ className, darkMode, ...attrs }, ref) => (
  <ul
    className={cx(className, {
      [styles.listbox]: true,
      [styles.darkMode]: darkMode,
    })}
    {...attrs}
    ref={ref}
  />
));
FormListbox.displayName = 'FormListbox';
